import { Dayjs } from 'dayjs'

export type InsIdentitySearchFilters = {
  surname: string
  givenName: string
  birthDate: Dayjs | null
  insNIR: string
}

export type InsIdentitySearchErrors = {
  birthDate?: string
  insNIR?: string
}

export const emptyInsIdentitySearchFilters: InsIdentitySearchFilters = {
  surname: '',
  givenName: '',
  birthDate: null,
  insNIR: '',
}
